import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AppShell } from "@/components/layout/AppShell";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/auth/ProtectedRoute";
import Login from "@/pages/Login";
import Uebersicht from "@/pages/Uebersicht";
import Objekt from "@/pages/Objekt";
import Investoren from "@/pages/Investoren";
import Dokumente from "@/pages/Dokumente";
import Aktivitaeten from "@/pages/Aktivitaeten";
import TopKandidaten from "@/pages/TopKandidaten";
import Bericht from "@/pages/Bericht";
import AdminUsers from "@/pages/AdminUsers";
import AdminDatenaudit from "@/pages/AdminDatenaudit";
import Datenraum from "@/pages/Datenraum";
import DatenraumInvestor from "@/pages/DatenraumInvestor";
import Vermietung from "@/pages/Vermietung";
import BilderVideos from "@/pages/BilderVideos";
import ExposeLinks from "@/pages/ExposeLinks";
import ExposePublic from "@/pages/ExposePublic";
import Placeholder from "@/pages/Placeholder";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          {/* Public Magic-Link für externe Investoren (KEIN Auth, KEIN AppShell) */}
          <Route path="/datenraum/:token" element={<DatenraumInvestor />} />
          {/* Public Exposé-Magic-Link (KEIN Auth, KEIN AppShell) */}
          <Route path="/expose/:token" element={<ExposePublic />} />
          <Route
            element={
              <ProtectedRoute>
                <AppShell />
              </ProtectedRoute>
            }
          >
            <Route index element={<Uebersicht />} />
            <Route path="/top-kandidaten" element={<TopKandidaten />} />
            <Route path="/objekt" element={<Objekt />} />
            <Route path="/investoren" element={<Investoren />} />
            <Route path="/dokumente" element={<Dokumente />} />
            <Route path="/datenraum" element={<Datenraum />} />
            <Route path="/vermietung" element={<Vermietung />} />
            <Route path="/bilder-videos" element={<BilderVideos />} />
            <Route path="/expose-links" element={<ExposeLinks />} />
            <Route path="/bericht" element={<Bericht />} />
            <Route
              path="/admin/users"
              element={
                <ProtectedRoute requireAdmin>
                  <AdminUsers />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/aktivitaeten"
              element={
                <ProtectedRoute requireAdmin>
                  <Aktivitaeten />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/datenaudit"
              element={
                <ProtectedRoute requireAdmin>
                  <AdminDatenaudit />
                </ProtectedRoute>
              }
            />
            <Route
              path="/pipeline"
              element={
                <Placeholder
                  testid="page-pipeline"
                  title="Pipeline"
                  phase="Phase 6"
                  description="Drag &amp; Drop-Pipeline folgt in einer späteren Phase. Bis dahin: nutzt /investoren mit Phase-Filter."
                />
              }
            />
            <Route
              path="*"
              element={
                <Placeholder
                  testid="page-404"
                  title="Seite nicht gefunden"
                  phase="404"
                  description="Diese Adresse existiert nicht. Bitte nutzen Sie die Navigation links."
                />
              }
            />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
